import { useEffect } from "react";
import { videoPreviewSubject } from "../../services/subscriberService";

export function IVSPreviewHandeler({ player }) {
  function showSpinner(id) {
    const getPreview = document.querySelector('[preview="' + id + '"]');
    if (getPreview) {
      const preview = (document.querySelector(
        '[preview="' + id + '"]'
      ).style.display = "flex");
      console.log("spinning");
    }
  }

  function hideSpinner(id) {
    const getPreview = document.querySelector('[preview="' + id + '"]');
    if (getPreview) {
      const preview = (document.querySelector(
        '[preview="' + id + '"]'
      ).style.display = "none");
      console.log("stopped");
    }
  }

  function hideAllSpinner() {
    var spinners = document.getElementsByClassName('spinner');
    for (var i = 0; i < spinners.length; i++) {
      spinners[i].style.display = 'none';
    }
  }

  useEffect(() => {
    const subscription = videoPreviewSubject.subscribe((data) => {
      if (data && player) {
        player.attachHTMLVideoElement(document.getElementById(data.id));
        player.load(data.url);
        player.setMuted(true);

        player.play();
        player.seekTo(30);
        showSpinner(data.id);

        player.addEventListener("Playing", function () {
          hideSpinner(data.id);
        });

      } else if (player) {
        player.pause();
        setTimeout(() => {
          hideAllSpinner()
        }, 2000);

      }
    });
    return () => {
      subscription.unsubscribe();
      if (player) {
        player.delete();
      }
    };
  }, [player]);
  return null;
}
